<template>
  <VDialog
    ref="loadingPopup"
    width="500px"
    class="loading-popup"
    position="center"
    not-hide-on-click
  >
    <template #header>
      {{ $core.utils.string.capitalize(title) }}
    </template>
    <div class="wrap">
      <div class="text">
        Идет {{ title }}, ожидайте...
      </div>
      <div class="loader" />
    </div>
  </VDialog>
</template>

<style lang="scss" src="./ReportsLoadingDialog.scss"/>

<script>

export default {
	name:   'ReportsLoadingDialog',

	props:  {
		visible: {
			type:     Boolean,
			required: true,
		},
		title: {
			type:     String,
			default:  'Загрузка',
			required: false,
		},
	},
};
</script>
